import { Component } from 'opus-angular-seed-core';
import animationData from './animation.json';

// the Coursy swirl of the loader over the page: the clip path is the logo, the stroke drawn along its centre fills it
const SWIRL_CLIP_PATH = [
    'M73 164c1.8-13 6.9-23.6 17-32.3 8.7-7.6 19.1-13.1 28.3-20.1 22.3-16.9 35.5-43.1',
    '25.1-70.4-4.5-11.8-12.7-22.4-23.6-29.2-11.2-7-25.7-8.9-38.7-9.7-25.6-1.8-55.7 4.2-71 26.2-15.7',
    '22.4-7.6 50.4 13.3 66.2 20.9 16 47.3 16.9 70.7 5.8 11.5-5.5 21.8-14.2 26.5-26.2 3.8-9.2 7.1-22.6',
    '1.2-31.6-5.3-8.3-19.8-11.5-26.9-3.7-7.7 8.7-1.4 22.2-10.7 30-8.7 7.4-26.2 10.3-36.2',
    '3.7-7.8-5.2-10.1-15-7.5-23.4 2.8-9.4 10.9-15.2 21-14.5 7.7.3 13.8 5.8 11.5 13.7-.8 3.2-4.1 8.2-7.6',
    '9.2-3.6 1.1-9.7-2.9-4.7-5.7 6.9-3.8.6-14.2-6.3-10.5-10.6 5.9-10.2 18.9-.7 25.7 11.6 8.1 25.1-1.3',
    '30-12.3 4.5-10.1 1.5-22.6-8.4-28.5-9-5.5-22.2-4.9-31.3.1-15.5 8.6-20.9 28.9-13.3 44.3 9.8 20 36.5',
    '21.1 54.7 11.9 12.2-6.1 15.8-16 17.3-28.6.5-4.3 2.6-12.4 8.6-5.5 3.4 4.1.6 12.8-.7 17.2-7.8',
    '26.1-44.2 36.3-67.7 26.3-12.6-5.3-23.9-15.5-27.7-28.8-3.8-13.2 1.8-27.2 12.5-36 10.9-8.9 25.9-12.2',
    '39.7-13.1 14-.6 31 .2 43.7 6.8 14.3 7.3 23.4 23.4 23.9 39.1.5 17-9.4 30.7-22.4 41-10.4 8.3-22.4',
    '14.4-32.3 23.3-10.7 9.7-17 22.3-18.8 36.5-1.5 7.4 10.4 10.8 11.5 3.1z'
].join(' ');
const SWIRL_STROKE_PATH = [
    'M66 170l4-20 4-9 5-6 10-10 31-22 11-13 5-9 3-7 2-14-3-15-7-13-10-11-13-8-16-4-23-1-20 3-16 6-12 8-5',
    '6-4 6-2 7-2 8 1 12 3 7 4 6 4 6 7 7 9 5 7 3 14 3 10 1 12-3 12-4 9-5 7-6 6-8 4-10 1-9 0-7-4-6-7-3-4',
    '1-4 5-6 19-6 8-6 4-7 2-7 2-7 0-12-3-8-6-5-9-1-9 2-10 5-8 6-5 9-3 7 0 7 2 6 5 3 7 0 4-1 5-4 6-4 3-6',
    '2-7-2-3-6 1-4 2-2 3 0 1 3'
].join(' ');

@Component({
    bindings: {
        width: '@?',    // e.g. "50px" or "100%"
        height: '@?',   // e.g. "50px" or "100%"
        message: '@?',  // optional message text
        overlay: '@?'   // "true": the Coursy loader over the page, below modals; width, height and message are not used
    },
    template: `
    <div class="coursy-loader-overlay" ng-if="vm.overlay === 'true'">
        <div class="coursy-loader" role="status" aria-label="{{ 'general.Loading' | translate }}">
            <svg width="72" height="83" viewBox="0 0 149 171" aria-hidden="true">
                <clipPath id="coursy-loader-swirl"><path d="${SWIRL_CLIP_PATH}"/></clipPath>
                <g clip-path="url(#coursy-loader-swirl)">
                    <rect width="149" height="171"/>
                    <path d="${SWIRL_STROKE_PATH}"/>
                </g>
            </svg>
            <p class="coursy-loader-title">{{ 'general.loader_title' | translate }}</p>
            <div class="coursy-loader-messages" aria-hidden="true">
                <p>{{ 'general.loader_waiting' | translate }}</p>
                <p>{{ 'general.loader_stretch' | translate }}</p>
                <p>{{ 'general.loader_fun_fact' | translate }}</p>
            </div>
        </div>
    </div>
    <div id="preloader" ng-hide="vm.overlay === 'true'">
        <div id="lottie-wrapper">
            <div id="lottie-container" class="lottie-container"
                ng-style="{
                    width: vm.width || '60px',
                    height: vm.height || '60px'
                }">
            </div>
            <div class="preloader-text" ng-if="vm.message">
                {{vm.message}}
            </div>
        </div>
    </div>

    <style>
        #preloader {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f4f4f4;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 10000;
            flex-direction: column;
        }

        #lottie-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
        }

        #lottie-container svg,
        #lottie-container canvas {
            width: 100% !important;
            height: 100% !important;
            display: block;
        }

        .preloader-text {
            margin-top: 20px;
            font-size: 17px;
            color: #555;
            font-weight: 500;
            letter-spacing: 0.4px;
            animation: textPulse 1.6s ease-in-out infinite;
        }

        @keyframes textPulse {
            0%, 100% {
                color: #555;
            }
            50% {
                color: #999;
            }
        }
    </style>
    `
})
export default class {
    constructor ($element, $scope) {
        this.$element = $element;
        this.$scope = $scope;
    }

    // AngularJS 1.5.0 knows only the $onInit lifecycle hook, the template is already in place there
    $onInit () {
        // the loader over the page is drawn in CSS, see _loader.less
        if (this.overlay === 'true') {
            return;
        }
        // the container of this loader, several loaders may be on the page at the same time
        // eslint-disable-next-line
        this.animation = lottie.loadAnimation({
            container: this.$element[0].querySelector('.lottie-container'),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid meet'
            }
        });
        this.$scope.$on('$destroy', () => this.animation.destroy());
    }
}



// WEBPACK FOOTER //
// ./src/app/components/loader/icon/index.js